import decode from "jwt-decode";
import BrowserStore from 'store2';
import 'isomorphic-fetch';

import { parseJSON, checkHttpStatus } from '../utils';

class ExploreAuth {
  constructor(baseUri = null) {
    /* global SERVER_URL */
    this.serverUri = baseUri || SERVER_URL;
  }

  tokenIsExpired(token) {
    const decodedToken = decode(token);
    if (decodedToken) {
      // Add a minute to the current time to eliminate async race condition
      const now = Math.floor(new Date().getTime() / 1000) + 60;
      return decodedToken.exp < now;
    }

    throw new Error('Invalid token provided');
  }

  getJwt() {
    return BrowserStore.get('token');
  }

  setJwt(token) {
    return BrowserStore.set('token', token);
  }

  refreshToken() {
    const token = this.getJwt();
    return fetch(`${this.serverUri}/auth/refresh`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
    .then(checkHttpStatus)
    .then(parseJSON)
    .then((response) => {
      this.setJwt(response.token);
      return response.token;
    })
    .then(newToken => newToken)
    .catch((err) => {
      throw new Error(err.message);
    });
  }

  getValidJwt() {
    const token = this.getJwt();

    if (!token) {
      return Promise.resolve(false);
    }

    if (this.tokenIsExpired(token)) {
      return this.refreshToken(token)
        .catch(() => {
          // A token that cannot be refreshed is useless. We could throw an
          // error here but functionally its the same as not having a token
          // at all. Just return false to be consistent.
          return false;
        });
    }

    return Promise.resolve(token);
  }
}

export default new ExploreAuth();
